var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 15 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8 12.8H1.6V1.6h5.6V0H1.6A1.6 1.6 0 000 1.6v11.2a1.6 1.6 0 001.6 1.6h11.2a1.6 1.6 0 001.6-1.6V7.2h-1.6zM8.8 0v1.6h2.88L3.84 9.44l1.12 1.12 7.84-7.84V5.6h1.6V0zm0 0"
  })));
}
export default __webpack_public_path__ + "88e6931af8689f8f1c5b8ec531999426.svg";
export { SvgLinkIcon as ReactComponent };